module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAAKVJREFUKBVjdFvy2JPhP+Os////yzAQARgZGB8zMP1PZ4FqEmdkZDxLhD4GoAV6jECLWEA2gTTtipUxIUaj2+InZ4B6jJmIUYxNDQu6oNvix7f//2dQQRFnZLy9O1ZGDVkMQ+OuWFlVZAW42CPeqYyMDHdwBRb9Q5Xs6GAEpr3HwLQHSuSXcEU2sjg4kTMyvmRhYPyfBkztM0EJF1kBLjbQgicgPQB+ckrc3LQJZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/containers/remote/records/info.png
// module id = 1507
// module chunks = 0